<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p>FORMULARIO DE DECLARACIÓN DE VENTA</p>
            </div>
            <p class="empadronamiento__form_header_info_text" style="text-align:justify;">
              Por favor, seleccione la unidad que declarará como vendida e ingrese los datos de el o los nuevos
              titulares
              para comenzar. Una vez iniciado el trámite, el nuevo titular recibirá un correo con la solicitud para
              continuar con el proceso de Empadronamiento para asociarse a la unidad.
            </p>

            <!-- Barrio  -->
            <div class="base-select loading-animation" v-if="loading"></div>
            <base-select v-else v-model="NeighborhoodId" @input="getUnits" placeholder="Barrio"
              :options="Neighborhoods" />

            <!-- Unidad -->
            <div class="base-select loading-animation" v-if="loadingUnit"></div>
            <base-select v-if="NeighborhoodId !== null && !loadingUnit" v-model="SellModel.UnitId"
              placeholder="Unidad *" :options="Units" :invalid="$v.SellModel.UnitId.$invalid && submitted" />

          </fieldset>

          <fieldset v-for="(titular, i) in SellModel.Titulars" :key="i">
            <template v-if="titular.PersonTypeId == 1">
              <div class="empadronamiento__intro__main__form__container-header space-between">
                <p>Información del comprador</p>
                <p class="delete" v-if="i > 0" @click="deleteTitular(i)">Eliminar</p>
              </div>
              <base-select placeholder="Tipo de persona *" v-model="titular.PersonTypeId"
                :options="Enums.ProcedureTitularPersonType"
                :invalid="$v.SellModel.Titulars.$each[i].PersonTypeId.$invalid && submitted"
                :disabled="isSecondPhysicalLocked(i)" @input="
                  (prop) => {
                    onPersonTypeChange(prop, i);
                  }
                " />
              <base-select v-if="LegalTitulars.length > 0" placeholder="Persona juridica relacionada *"
                v-model="titular.RelatedLegalTitular" :options="LegalTitulars" :invalid="false" />
              <base-input v-model.trim="titular.FirstName" name="Nombre *" placeholder="Nombre *"
                :invalid="$v.SellModel.Titulars.$each[i].FirstName.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].FirstName.$invalid" style="color:red;">
                  {{ titular.PersonTypeId == null || titular.PersonTypeId != 2 ? 'El Nombre es obligatorio.' : 'La Razón Social es obligatoria.' }}
                </small>

              <base-input v-model.trim="titular.LastName" name="Apellido *" placeholder="Apellido *"
                :invalid="$v.SellModel.Titulars.$each[i].LastName.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].LastName.$invalid" style="color:red;">
                  {{ titular.PersonTypeId == null || titular.PersonTypeId != 2 ? 'El Apellido es obligatorio.' : 'El Nombre de fantasía es obligatorio.' }}
                </small>

              <base-input v-model.trim="titular.Email" name="Mail *" placeholder="Mail del nuevo propietario *"
                :invalid="$v.SellModel.Titulars.$each[i].Email.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].Email.$invalid" style="color:red;">
                  El mail es obligatorio y debe contener un formato válido (ej: email@email.com).
                </small>

              <base-input v-model.trim="titular.Phone" name="Telefono *" placeholder="Telefono *"
                :invalid="$v.SellModel.Titulars.$each[i].Phone.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].Phone.$invalid" style="color:red;">
                  El teléfono es obligatorio y solo debe contener números.
                </small>

              <base-select v-if="titular.PersonTypeId == 1" placeholder="Tipo de documento *"
                v-model="titular.IdentificationTypeId" :options="Enums.IdentificationType"
                :invalid="titular.PersonTypeId == 1 && titular.IdentificationTypeId == '' && submitted" />

              <base-input v-if="titular.PersonTypeId == 1"
                :placeholder="isDNI(titular.IdentificationTypeId) ? 'Documento * (ej: 35960655)' : 'Pasaporte * (ej: AA123456)'"
                :value="titular.Identification"
                @input="val => { titular.Identification = normalizeDoc(val, titular.IdentificationTypeId) }"
                @blur="val => { titular.Identification = normalizeDoc(val, titular.IdentificationTypeId) }"
                :invalid="(titular.PersonTypeId == 1 && titular.Identification == '' && submitted) || (submitted && !!docFormatError(titular.Identification, titular.IdentificationTypeId))" />
              <small v-if="submitted && docFormatError(titular.Identification, titular.IdentificationTypeId)" style="color:red;">
                {{ docFormatError(titular.Identification, titular.IdentificationTypeId) }}
              </small>
            </template>

            <template v-if="titular.PersonTypeId == 2">
              <div class="empadronamiento__intro__main__form__container-header space-between">
                <p>Información del comprador</p>
                <p class="delete" v-if="i > 0" @click="deleteTitular(i)">Eliminar</p>
              </div>
              <base-select placeholder="Tipo de persona *" v-model="titular.PersonTypeId"
                :options="Enums.ProcedureTitularPersonType"
                :invalid="$v.SellModel.Titulars.$each[i].PersonTypeId.$invalid && submitted" @input="
                  (prop) => {
                    onPersonTypeChange(prop, i);
                  }
                " />
              <base-input v-model.trim="titular.FirstName" name="Razon Social *" placeholder="Razon Social *"
                :invalid="$v.SellModel.Titulars.$each[i].FirstName.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].FirstName.$invalid" style="color:red;">
                  {{ titular.PersonTypeId == 2 ? 'La Razón Social es obligatoria.' : 'El Nombre es obligatorio.' }}
                </small>
              <base-input v-model.trim="titular.LastName" name="Nombre de fantasía *" placeholder="Nombre de fantasía *"
                :invalid="$v.SellModel.Titulars.$each[i].LastName.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].LastName.$invalid" style="color:red;">
                  {{ titular.PersonTypeId == 2 ? 'El Nombre de fantasía es obligatorio.' : 'El Apellido es obligatorio.' }}
                </small>
              <base-input v-model.trim="titular.Email" name="Mail *" placeholder="Mail *"
                :invalid="$v.SellModel.Titulars.$each[i].Email.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].Email.$invalid" style="color:red;">
                  El mail es obligatorio y debe contener un formato válido (ej: email@email.com).
                </small>

              <base-input v-model.trim="titular.Phone" name="Telefono *" placeholder="Telefono *"
                :invalid="$v.SellModel.Titulars.$each[i].Phone.$invalid && submitted" />
                <small v-if="submitted && $v.SellModel.Titulars.$each[i].Phone.$invalid" style="color:red;">
                  El teléfono es obligatorio y solo debe contener números.
                </small>

              <base-input v-if="titular.PersonTypeId == 2" placeholder="CUIT *"
                :value="titular.CUIL"
                @input="val => { titular.CUIL = val.replace(/\D/g, '') }"
                :invalid="titular.PersonTypeId == 2 && titular.CUIL == '' && submitted" />
                <small v-if="submitted && titular.PersonTypeId == 2 && titular.CUIL == '' " style="color:red;">
                  El CUIT es obligatorio.
                </small>
            </template>

          </fieldset>

          <base-add-section label="Agregar comprador" @click="addTitular" />
        </form>
        <div v-if="this.showRelatedTitularNeededMessage">
          Debe agregar al menos una persona fisica relacionada a la persona juridica.
        </div>
        <div class="empadronamiento__intro__button">
          <div></div>
          <button v-if="!loadingForm" class="active" @click="saveTitulars">Guardar</button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, email } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      loading: true,
      loadingUnit: false,
      NeighborhoodId: 0,
      Units: [],
      submitted: false,
      loadingForm: false,
      showRelatedTitularNeededMessage: false
    };
  },
  computed: {
    ...mapState({
      Enums: state => state.neighregistration.Enums,
      SellModel: state => state.manageVecino.sellModel,
      Neighborhoods: state => state.unit.Neighborhoods,
    }),
    LegalTitulars() {
      return this.SellModel.Titulars.filter(t => t.PersonTypeId == 2).map(tr => ({ Id: tr.UniqueCode, Name: `${tr.FirstName} ${tr.LastName}` }));
    }
  },
  created() {
    // Loguear al usuario
    this.$store.dispatch("logIn", this.$route.query.personToken)
      .then(() => {
        this.$store.dispatch("loggedIn", true);
        this.$store.dispatch("getEnums");
        this.$store.dispatch("getNeighborhoods");
        this.loading = false
      })
  },
  methods: {
    onPersonTypeChange(prop, index) {
      if (this.SellModel.Titulars[index].PersonTypeId == 1) {
        //Fisica
        this.SellModel.Titulars[index].CUIL = "";
      }
      if (this.SellModel.Titulars[index].PersonTypeId == 2) {
        //Jurdica
        this.SellModel.Titulars[index].Identification = "";
      }
    },
    getUnits() {
      const self = this;
      self.loadingUnit = true;
      this.$store.dispatch("getUnits", this.NeighborhoodId).then(units => {
        self.Units = units;
        self.loadingUnit = false;
      });
    },
    addTitular() {
      this.$store.dispatch("addTitularSell");
      this.showRelatedTitularNeededMessage = false;

      const t = this.SellModel.Titulars;
      const idx = t.length - 1;
      const idTypes = this.Enums && this.Enums.IdentificationType;
      const defaultIdType = (idTypes && idTypes[0]) ? idTypes[0].Id : null;


      this.$set(t[idx], "PersonTypeId", 1);
      if (defaultIdType !== null) {
        this.$set(t[idx], "IdentificationTypeId", defaultIdType);
      }
      if (t.length === 2 && t[0] && t[0].PersonTypeId == 2) {
        this.$set(t[1], 'PersonTypeId', 1);

        const relatedId = t[0] && (t[0].UniqueCode != null ? t[0].UniqueCode : t[0].Id);

        if (relatedId) {
          this.$set(t[1], 'RelatedLegalTitular', relatedId);
        }
      }
    },
    isSecondPhysicalLocked(i) {
      const titulars = this.SellModel && this.SellModel.Titulars;
      const t0 = titulars && titulars.length > 0 ? titulars[0] : null;
      return !!(t0 && Number(t0.PersonTypeId) === 2 && i === 1);
    },

    deleteTitular(index) {
      this.$store.dispatch("removeTitularSell", index)
    },
    // Retorna true si el tipo de documento seleccionado es DNI (numérico, requiere sanitización)
    isDNI(identificationTypeId) {
      const types = this.Enums && this.Enums.IdentificationType;
      if (!types || !identificationTypeId) return true; // por defecto sanitizar
      const found = types.find(t => t.Id == identificationTypeId);
      return !found || found.Code === 'DNI' || found.Name === 'DNI';
    },
    // Normaliza el valor según el tipo: DNI quita puntos/guiones, pasaporte quita espacios/guiones y pone mayúsculas
    normalizeDoc(val, identificationTypeId) {
      if (this.isDNI(identificationTypeId)) {
        // DNI: solo digitos
        return val.replace(/\D/g, '');
      }
      // Pasaporte: solo letras y digitos, mayusculas
      return val.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    },
    // Retorna mensaje de error si el formato no es válido, null si es correcto
    docFormatError(val, identificationTypeId) {
      if (!val) return null;
      if (this.isDNI(identificationTypeId)) {
        return /^\d{7,8}$/.test(val) ? null : 'El DNI debe contener entre 7 y 8 dígitos.';
      }
      return /^[A-Z]{1,3}[0-9]{6,}$/.test(val) ? null : 'El pasaporte debe comenzar con 1 a 3 letras seguidas de numeros. Ej: AA123456';
    },
    saveTitulars() {
      this.submitted = true
      if (!this.$v.SellModel.$invalid) {
        if (this.SellModel.Titulars.filter(t => t.PersonTypeId == 1).length > 0) {
          this.loadingForm = true;
          this.$store.dispatch("createSellProcedure")
        }
        else {
          //TODO: mostrar mensaje
          this.showRelatedTitularNeededMessage = true;
        }
      }
      else {
        var element = document.querySelector(".empadronamiento__intro__main__form__container-item .has-error");
        if (element != null)
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    },
    //
    isPhysicalPerson(titular) {
      return Number(titular.PersonTypeId) === 1;
    },
    isLegalPerson(titular) {
      return Number(titular.PersonTypeId) === 2;
    },
    isInputValid(val) {
      return !!val && String(val).trim().length > 0;
    }
  },
  validations: {
    SellModel: {
      UnitId: {
        required
      },
      Titulars: {
        $each: {
          FirstName: {
            required: function(val, titular) {
              if (this.isPhysicalPerson(titular) || this.isLegalPerson(titular)) {
                return this.isInputValid(val);
              }
              return true;
            }
          },
          LastName: {
            required: function(val, titular) {
              if (this.isPhysicalPerson(titular) || this.isLegalPerson(titular)) {
                return this.isInputValid(val);
              }
              return true;
            }
          },
          Email: {
            required: function(val, titular) {
              if (this.isPhysicalPerson(titular) || this.isLegalPerson(titular)) {
                return email(val) && this.isInputValid(val);
              }
              return true;
            }
          },
          Phone: {
            required: function(val, titular) {
              if (this.isPhysicalPerson(titular) || this.isLegalPerson(titular)) {
                return this.isInputValid(val) && (/^[0-9]+$/.test(val));
              }
              return true;
            }
          },
          PersonTypeId: {
            required
          },
          IdentificationTypeId: {
            required: function(val, titular) {
              return titular.PersonTypeId == 1 ? !!val : true;
            }
          },
          Identification: {
            validFormat (val, titular) {
              if (titular.PersonTypeId != 1) return true;
              return !this.docFormatError(val, titular.IdentificationTypeId);
            }
          }
        }
      }
    }
  }
};
</script>
